let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eICYS")).then(() => parcelRequire('jFjao'));